export default "__VITE_ASSET__BQygnqGn__"